import { render, staticRenderFns } from "./b-ticket-additional-info.vue?vue&type=template&id=04cfe72e&scoped=true"
import script from "./b-ticket-additional-info.vue?vue&type=script&lang=ts"
export * from "./b-ticket-additional-info.vue?vue&type=script&lang=ts"
import style0 from "./b-ticket-additional-info.vue?vue&type=style&index=0&id=04cfe72e&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cfe72e",
  null
  
)

export default component.exports